import { render, staticRenderFns } from "./hdqList.vue?vue&type=template&id=47a62f2b&scoped=true"
import script from "./hdqList.vue?vue&type=script&lang=js"
export * from "./hdqList.vue?vue&type=script&lang=js"
import style0 from "./hdqList.vue?vue&type=style&index=0&id=47a62f2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a62f2b",
  null
  
)

export default component.exports